(function () {
  /* Agrotropic Grusskarten Modul */
  const MESSAGE_MIN = 10;
  const MESSAGE_MAX = 300;

  function getGreetingCardStrings() {
    return window.greetingCardStrings || {};
  }

  function formatGreetingCardString(template, replacements) {
    if (!template) return '';
    let result = String(template);
    if (!replacements) return result;

    Object.keys(replacements).forEach(function (key) {
      result = result.split('[' + key + ']').join(String(replacements[key]));
    });

    return result;
  }

  function isProductLineNoteValid(form) {
    return !window.agrotropicProductLineNote || window.agrotropicProductLineNote.validate(form);
  }

  function normalizeMessageForProperty(value) {
    return String(value || '')
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .trim();
  }

  function initGreetingCardAddon(sectionId, productFormId) {
    const strings = getGreetingCardStrings();
    const sectionSelector = '#MainProduct-' + sectionId;
    let bypassGreetingCard = false;
    let isTransitioning = false;

    const wizard = {
      mainQty: 1,
      cardCount: 0,
      step: 'single',
      currentCardIndex: 0,
      cards: [],
    };

    function setElementVisible(element, visible) {
      if (!element) return;
      element.classList.toggle('flower-addon-is-hidden', !visible);
      element.hidden = !visible;
      element.tabIndex = visible ? 0 : -1;
    }

    function getProductForm() {
      return document.getElementById(productFormId);
    }

    function getProductFormComponent() {
      const section = document.querySelector(sectionSelector);
      return section ? section.querySelector('product-form') : null;
    }

    function getSubmitButton() {
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }

    function getQuantityInput() {
      return (
        document.getElementById('Quantity-' + sectionId) ||
        document.querySelector(sectionSelector + ' input[name="quantity"]')
      );
    }

    function readQuantityFromInput(qtyInput) {
      if (!qtyInput) return 1;
      const qty = parseInt(qtyInput.value, 10);
      return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }

    function getMainQuantity() {
      return readQuantityFromInput(getQuantityInput());
    }

    function getProductTitle() {
      const titleEl = document.querySelector(sectionSelector + ' .product__title');
      return titleEl ? titleEl.textContent.trim() : '';
    }

    function getModalElements() {
      return {
        modal: document.getElementById('flower-addon-modal'),
        title: document.getElementById('flower-addon-modal-title'),
        nav: document.getElementById('flower-addon-nav'),
        stepCount: document.getElementById('flower-addon-step-count'),
        stepIntro: document.getElementById('flower-addon-step-intro'),
        stepCard: document.getElementById('flower-addon-step-card'),
        countInput: document.getElementById('flower-addon-card-count'),
        countDescription: document.getElementById('flower-addon-count-description'),
        countError: document.getElementById('flower-addon-count-error'),
        backButton: document.getElementById('flower-addon-back'),
        nextButton: document.getElementById('flower-addon-next'),
        confirmButton: document.getElementById('flower-addon-confirm'),
        skipButton: document.getElementById('flower-addon-skip'),
        selectedVariantInput: document.getElementById('flower-addon-selected-variant'),
        variantCards: document.querySelectorAll('.flower-addon-card'),
      };
    }

    function getActiveTextarea() {
      const activePanel = document.querySelector('.flower-addon-message-panel:not(.flower-addon-is-hidden)');
      if (activePanel) {
        return activePanel.querySelector('textarea');
      }
      return document.getElementById('flower-addon-text-active');
    }

    function getMessageElements() {
      return {
        textField: getActiveTextarea(),
        errorEl: document.getElementById('flower-addon-text-error'),
        counterEl: document.getElementById('flower-addon-text-counter'),
      };
    }

    function updateMessageCounter(textarea) {
      const textField = textarea || getActiveTextarea();
      const counterEl = document.getElementById('flower-addon-text-counter');
      if (!textField || !counterEl) return;

      const length = textField.value.length;
      counterEl.textContent = length + ' / ' + MESSAGE_MAX;
      counterEl.classList.toggle('is-invalid', length > 0 && length < MESSAGE_MIN);
    }

    function destroyMessagePanels() {
      const container = document.getElementById('flower-addon-message-panels');
      if (container) container.innerHTML = '';
    }

    function buildMessagePanels(count) {
      const container = document.getElementById('flower-addon-message-panels');
      if (!container) return;

      container.innerHTML = '';

      for (let i = 0; i < count; i += 1) {
        const card = ensureCardSlot(i);
        const panel = document.createElement('div');
        panel.className = 'flower-addon-message-panel';
        panel.dataset.cardIndex = String(i);

        if (i !== wizard.currentCardIndex) {
          panel.classList.add('flower-addon-is-hidden');
        }

        const textarea = document.createElement('textarea');
        textarea.className = 'flower-addon-text-input';
        textarea.rows = 4;
        textarea.maxLength = MESSAGE_MAX;
        textarea.setAttribute('aria-required', 'true');
        textarea.placeholder = strings.messagePlaceholder || '';
        textarea.autocomplete = 'off';
        textarea.value = card.message || '';

        if (i === wizard.currentCardIndex) {
          textarea.id = 'flower-addon-text-active';
        }

        const cardIndex = i;
        textarea.addEventListener('input', function () {
          ensureCardSlot(cardIndex).message = textarea.value;
          clearMessageError();
          updateMessageCounter(textarea);
        });

        panel.appendChild(textarea);
        container.appendChild(panel);
      }

      updateMessageCounter(getActiveTextarea());
    }

    function showMessagePanel(index) {
      document.querySelectorAll('.flower-addon-message-panel').forEach(function (panel) {
        const panelIndex = parseInt(panel.dataset.cardIndex, 10);
        const isActive = panelIndex === index;

        panel.classList.toggle('flower-addon-is-hidden', !isActive);

        const textarea = panel.querySelector('textarea');
        if (!textarea) return;

        if (isActive) {
          textarea.id = 'flower-addon-text-active';
        } else {
          textarea.removeAttribute('id');
        }
      });

      updateMessageCounter(getActiveTextarea());
    }

    function setMessageError(message) {
      const { textField, errorEl } = getMessageElements();
      if (textField) textField.classList.add('flower-addon-text--error');
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
    }

    function clearMessageError() {
      const { textField, errorEl } = getMessageElements();
      if (textField) textField.classList.remove('flower-addon-text--error');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }

    function setCountError(message) {
      const { countInput, countError } = getModalElements();
      if (countInput) countInput.classList.add('flower-addon-text--error');
      if (countError) {
        countError.textContent = message;
        countError.hidden = false;
      }
    }

    function clearCountError() {
      const { countInput, countError } = getModalElements();
      if (countInput) countInput.classList.remove('flower-addon-text--error');
      if (countError) {
        countError.textContent = '';
        countError.hidden = true;
      }
    }

    function validateMessage() {
      const { textField } = getMessageElements();
      if (!textField) return false;

      const message = textField.value.trim();

      if (message.length < MESSAGE_MIN) {
        setMessageError(formatGreetingCardString(strings.errorMinChars, { min: MESSAGE_MIN }));
        textField.focus();
        return false;
      }

      if (message.length > MESSAGE_MAX) {
        setMessageError(formatGreetingCardString(strings.errorMaxChars, { max: MESSAGE_MAX }));
        textField.focus();
        return false;
      }

      clearMessageError();
      return true;
    }

    function validateCurrentCard() {
      const { selectedVariantInput } = getModalElements();

      if (!selectedVariantInput || !selectedVariantInput.value) {
        alert(strings.errorSelectCard || '');
        return false;
      }

      return validateMessage();
    }

    function ensureCardSlot(index) {
      if (!wizard.cards[index]) {
        wizard.cards[index] = { variantId: '', message: '' };
      }
      return wizard.cards[index];
    }

    function getPanelTextarea(index) {
      const panel = document.querySelector('.flower-addon-message-panel[data-card-index="' + index + '"]');
      return panel ? panel.querySelector('textarea') : null;
    }

    function saveCardFromDom(index) {
      if (index < 0) return;

      const card = ensureCardSlot(index);
      const panelTextarea = getPanelTextarea(index);
      const { selectedVariantInput } = getModalElements();

      if (panelTextarea) {
        card.message = String(panelTextarea.value || '');
      }

      if (selectedVariantInput && wizard.currentCardIndex === index) {
        card.variantId = String(selectedVariantInput.value || '');
      }
    }

    function saveCurrentCardToState() {
      if (wizard.step === 'card') {
        saveCardFromDom(wizard.currentCardIndex);
        return;
      }

      if (wizard.step === 'single') {
        const { selectedVariantInput } = getModalElements();
        const { textField } = getMessageElements();
        const card = ensureCardSlot(0);
        card.variantId = selectedVariantInput ? String(selectedVariantInput.value || '') : '';
        card.message = textField ? String(textField.value || '') : '';
      }
    }

    function isCardComplete(card) {
      return card && card.variantId && String(card.message || '').trim().length >= MESSAGE_MIN;
    }

    function loadCardFromState(index) {
      if (index < 0 || index >= wizard.cardCount) return;

      const previousIndex = wizard.currentCardIndex;
      if (wizard.step === 'card' && previousIndex !== index) {
        saveCardFromDom(previousIndex);
      }

      wizard.currentCardIndex = index;
      const card = ensureCardSlot(index);
      const variantId = card.variantId ? String(card.variantId) : '';
      const { selectedVariantInput, variantCards } = getModalElements();

      showMessagePanel(index);

      const panelTextarea = getPanelTextarea(index);
      if (panelTextarea && panelTextarea.value !== (card.message || '')) {
        panelTextarea.value = card.message || '';
      }

      if (selectedVariantInput) {
        selectedVariantInput.value = variantId;
      }

      variantCards.forEach(function (variantCard) {
        const isSelected = variantCard.dataset.variantId === variantId;
        variantCard.classList.toggle('is-selected', isSelected);
        variantCard.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      clearMessageError();
      updateMessageCounter(getActiveTextarea());
      updateStepUI();
    }

    function renderNav() {
      const { nav } = getModalElements();
      if (!nav) return;

      if (wizard.step !== 'card' || wizard.cardCount <= 1) {
        nav.hidden = true;
        nav.innerHTML = '';
        return;
      }

      nav.hidden = false;
      nav.innerHTML = '';

      for (let i = 0; i < wizard.cardCount; i += 1) {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'flower-addon-nav__tab';
        tab.textContent = formatGreetingCardString(strings.cardTab, { number: i + 1 });
        tab.setAttribute('aria-label', formatGreetingCardString(strings.cardTabAria, { number: i + 1 }));

        if (i === wizard.currentCardIndex) {
          tab.classList.add('is-active');
          tab.setAttribute('aria-current', 'step');
        }

        if (isCardComplete(wizard.cards[i])) {
          tab.classList.add('is-complete');
        }

        tab.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (isTransitioning || wizard.currentCardIndex === i) return;

          saveCurrentCardToState();
          isTransitioning = true;
          setTimeout(function () {
            loadCardFromState(i);
            isTransitioning = false;
          }, 50);
        });

        nav.appendChild(tab);
      }
    }

    function updateStepUI() {
      const els = getModalElements();

      setElementVisible(els.stepCount, wizard.step === 'count');
      setElementVisible(els.stepIntro, wizard.step === 'intro');
      setElementVisible(els.stepCard, wizard.step === 'card' || wizard.step === 'single');

      setElementVisible(els.backButton, false);
      setElementVisible(els.nextButton, false);
      setElementVisible(els.confirmButton, false);
      setElementVisible(els.skipButton, false);

      if (!els.title) return;

      if (wizard.step === 'count') {
        els.title.textContent = strings.modalTitleCount || '';
        setElementVisible(els.skipButton, true);
        setElementVisible(els.nextButton, true);
        els.nextButton.textContent = strings.next || '';
        if (els.nav) els.nav.hidden = true;
        return;
      }

      if (wizard.step === 'intro') {
        els.title.textContent = strings.modalTitleIntro || '';
        setElementVisible(els.backButton, true);
        setElementVisible(els.nextButton, true);
        els.nextButton.textContent = strings.next || '';
        if (els.nav) els.nav.hidden = true;
        return;
      }

      if (wizard.step === 'single') {
        els.title.textContent = strings.modalTitleSingle || '';
        setElementVisible(els.confirmButton, true);
        els.confirmButton.textContent = strings.confirmSingle || '';
        setElementVisible(els.skipButton, true);
        if (els.nav) els.nav.hidden = true;
        return;
      }

      if (wizard.step === 'card') {
        els.title.textContent = formatGreetingCardString(strings.modalTitleCard, {
          current: wizard.currentCardIndex + 1,
          total: wizard.cardCount,
        });
        setElementVisible(els.backButton, true);
        renderNav();

        const isLastCard = wizard.currentCardIndex === wizard.cardCount - 1;

        if (isLastCard) {
          setElementVisible(els.confirmButton, true);
          els.confirmButton.textContent = strings.confirmMultiple || '';
        } else {
          setElementVisible(els.nextButton, true);
          els.nextButton.textContent = strings.next || '';
        }
      }
    }

    function resetWizardState() {
      wizard.mainQty = 1;
      wizard.cardCount = 0;
      wizard.step = 'single';
      wizard.currentCardIndex = 0;
      wizard.cards = [];
    }

    function resetCardEditor() {
      const { selectedVariantInput, variantCards } = getModalElements();
      destroyMessagePanels();
      if (selectedVariantInput) selectedVariantInput.value = '';
      clearMessageError();
      clearCountError();
      updateMessageCounter();
      variantCards.forEach(function (card) {
        card.classList.remove('is-selected');
        card.setAttribute('aria-pressed', 'false');
      });
    }

    function resetModal() {
      isTransitioning = false;
      resetCardEditor();
      resetWizardState();
      updateStepUI();
    }

    function openModal() {
      const { modal, countInput, countDescription } = getModalElements();
      if (!modal) return;

      resetCardEditor();
      wizard.mainQty = getMainQuantity();

      if (wizard.mainQty > 1) {
        wizard.step = 'count';
        wizard.cardCount = 0;
        wizard.currentCardIndex = 0;
        wizard.cards = [];

        if (countInput) {
          countInput.min = '0';
          countInput.max = String(wizard.mainQty);
          countInput.value = String(Math.min(1, wizard.mainQty));
        }

        if (countDescription) {
          countDescription.textContent = formatGreetingCardString(strings.countDescription, {
            quantity: wizard.mainQty,
          });
        }
      } else {
        wizard.step = 'single';
        wizard.cardCount = 1;
        wizard.currentCardIndex = 0;
        wizard.cards = [{ variantId: '', message: '' }];
        buildMessagePanels(1);
      }

      updateStepUI();
      modal.style.display = 'flex';
    }

    function closeModal() {
      const { modal } = getModalElements();
      if (!modal) return;
      modal.style.display = 'none';
    }

    function collectFormLineItemProperties(form) {
      const properties = {};
      const formData = new FormData(form);

      formData.forEach(function (value, key) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') {
          properties[match[1]] = value;
        }
      });

      return properties;
    }

    function getSelectedProductAddonVariantIds() {
      const root = document.querySelector('[data-agrotropic-product-addons]');
      if (!root) return [];

      return Array.from(root.querySelectorAll('.agrotropic-product-addon-card.is-selected'))
        .map(function (card) {
          return card.dataset.variantId;
        })
        .filter(function (variantId) {
          return Boolean(variantId);
        });
    }

    function buildProductAddonCartItem(variantId, quantity, productTitle, parentRef) {
      const item = {
        id: parseInt(variantId, 10),
        quantity: quantity,
        properties: {
          Für: productTitle,
          _product_addon: 'true',
        },
      };

      if (parentRef.parent_line_key) {
        item.parent_line_key = parentRef.parent_line_key;
      } else {
        item.parent_id = parentRef.parent_id;
      }

      return item;
    }

    function normalizeComparableProperties(properties) {
      const result = {};
      if (!properties) return result;

      Object.keys(properties).forEach(function (key) {
        if (key.charAt(0) === '_') return;
        const value = properties[key];
        if (value === null || value === undefined || value === '') return;
        result[key] = String(value);
      });

      return result;
    }

    function propertiesEqual(leftProperties, rightProperties) {
      const left = normalizeComparableProperties(leftProperties);
      const right = normalizeComparableProperties(rightProperties);
      const leftKeys = Object.keys(left).sort();
      const rightKeys = Object.keys(right).sort();

      if (leftKeys.length !== rightKeys.length) return false;

      return leftKeys.every(function (key, index) {
        return key === rightKeys[index] && left[key] === right[key];
      });
    }

    function findExistingParentLine(cart, variantId, properties) {
      if (!cart || !cart.items || !cart.items.length) return null;

      return (
        cart.items.find(function (item) {
          if (Number(item.variant_id) !== Number(variantId)) return false;
          if (item.parent_relationship && item.parent_relationship.parent_key) return false;
          return propertiesEqual(item.properties, properties);
        }) || null
      );
    }

    function fetchCart() {
      return fetch(`${window.Shopify?.routes?.root || '/'}cart.js?timestamp=${Date.now()}`, {
        credentials: 'same-origin',
        cache: 'no-store',
      }).then(function (response) {
        if (!response.ok) throw new Error(strings.errorAddToCart || 'Cart fetch failed');
        return response.json();
      });
    }

    function cartChangeQuantity(lineKey, quantity) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.cache = 'no-store';
      config.body = JSON.stringify({
        id: lineKey,
        quantity: quantity,
      });

      return fetch(routes.cart_change_url, config).then(function (response) {
        return response.json();
      });
    }

    function buildParentItem(form, variantId, quantity) {
      const parentVariantId = parseInt(variantId, 10);
      const bouquetProperties = collectFormLineItemProperties(form);
      const mainItem = {
        id: parentVariantId,
        quantity: quantity,
      };

      if (Object.keys(bouquetProperties).length > 0) {
        mainItem.properties = bouquetProperties;
      }

      const sellingPlanInput = form.querySelector('[name="selling_plan"]');
      if (sellingPlanInput && sellingPlanInput.value) {
        mainItem.selling_plan = parseInt(sellingPlanInput.value, 10);
      }

      return {
        mainItem: mainItem,
        parentVariantId: parentVariantId,
        bouquetProperties: bouquetProperties,
      };
    }

    function buildNestedChildItems(quantity, greetingCards, productTitle, parentRef) {
      const items = [];

      greetingCards.forEach(function (card, index) {
        const cardQuantity = greetingCards.length > 1 ? 1 : quantity;
        const item = {
          id: parseInt(card.variantId, 10),
          quantity: cardQuantity,
          properties: buildGreetingCardProperties(card, productTitle, index, greetingCards.length),
        };

        if (parentRef.parent_line_key) {
          item.parent_line_key = parentRef.parent_line_key;
        } else {
          item.parent_id = parentRef.parent_id;
        }

        items.push(item);
      });

      getSelectedProductAddonVariantIds().forEach(function (addonVariantId) {
        items.push(buildProductAddonCartItem(addonVariantId, quantity, productTitle, parentRef));
      });

      return items;
    }

    function buildFirstAddItems(form, variantId, quantity, greetingCards, productTitle) {
      const parent = buildParentItem(form, variantId, quantity);
      return [parent.mainItem].concat(
        buildNestedChildItems(quantity, greetingCards, productTitle, {
          parent_id: parent.parentVariantId,
        })
      );
    }

    function buildGreetingCardProperties(card, productTitle, cardIndex, totalCards) {
      const properties = {
        Grusskartentext: normalizeMessageForProperty(card.message),
        Für: productTitle,
        _greeting_card_addon: 'true',
      };

      if (totalCards > 1) {
        properties.Grusskarte = cardIndex + 1 + ' / ' + totalCards;
      }

      return properties;
    }

    function beginFormLoading(productFormComponent) {
      if (!productFormComponent) return;

      productFormComponent.handleErrorMessage();
      productFormComponent.submitButton.setAttribute('aria-disabled', 'true');
      productFormComponent.submitButton.classList.add('loading');
      productFormComponent.querySelector('.loading__spinner').classList.remove('hidden');
    }

    function endFormLoading(productFormComponent) {
      if (!productFormComponent) return;

      productFormComponent.submitButton.classList.remove('loading');
      productFormComponent.querySelector('.loading__spinner').classList.add('hidden');

      if (!productFormComponent.error) {
        productFormComponent.submitButton.removeAttribute('aria-disabled');
      }
    }

    // JSON cart add — reliable for nested items with line item properties.
    function dawnCartAddItems(items, shouldRenderDrawer) {
      const cartDrawer = document.querySelector('cart-drawer');
      const body = { items: items };

      if (shouldRenderDrawer && cartDrawer) {
        body.sections = cartDrawer
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',');
        body.sections_url = window.location.pathname;
        cartDrawer.setActiveElement(document.activeElement);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.cache = 'no-store';
      config.body = JSON.stringify(body);

      return fetch(routes.cart_add_url, config).then(function (response) {
        return response.json();
      });
    }

    function assertCartAddOk(response, productFormComponent) {
      if (!response.status) return response;

      if (productFormComponent) {
        productFormComponent.handleErrorMessage(response.description);
        productFormComponent.error = true;
      }

      publish(PUB_SUB_EVENTS.cartError, {
        source: 'greeting-card-addon',
        errors: response.errors || response.description,
        message: response.message,
      });

      throw new Error(response.description || strings.errorAddToCart || '');
    }

    function finishDrawerUpdate(response, productFormComponent, variantId) {
      const cartDrawer = document.querySelector('cart-drawer');

      if (!cartDrawer) {
        window.location = window.routes.cart_url;
        return;
      }

      if (productFormComponent) {
        productFormComponent.error = false;
      }

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'greeting-card-addon',
        productVariantId: variantId,
        cartData: response,
      }).then(function () {
        CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      });

      CartPerformance.measure('add:paint-updated-sections', function () {
        cartDrawer.renderContents(response);
      });

      if (cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
    }

    function submitCartWithGreetingCards(greetingCards) {
      const form = getProductForm();
      const productFormComponent = getProductFormComponent();

      if (!form || !productFormComponent) {
        return Promise.resolve();
      }

      if (!isProductLineNoteValid(form)) {
        return Promise.resolve();
      }

      const productTitle = getProductTitle();
      const variantId = form.querySelector('[name="id"]').value;
      const quantity = getMainQuantity();

      beginFormLoading(productFormComponent);

      const parent = buildParentItem(form, variantId, quantity);

      return fetchCart()
        .then(function (cart) {
          const existingParent = findExistingParentLine(
            cart,
            parent.parentVariantId,
            parent.bouquetProperties
          );

          if (existingParent) {
            return cartChangeQuantity(existingParent.key, existingParent.quantity + quantity).then(
              function (changeResponse) {
                if (changeResponse.status) {
                  throw new Error(changeResponse.description || strings.errorAddToCart || '');
                }

                return dawnCartAddItems(
                  buildNestedChildItems(quantity, greetingCards, productTitle, {
                    parent_line_key: existingParent.key,
                  }),
                  true
                );
              }
            );
          }

          return dawnCartAddItems(
            buildFirstAddItems(form, variantId, quantity, greetingCards, productTitle),
            true
          );
        })
        .then(function (response) {
          assertCartAddOk(response, productFormComponent);
          finishDrawerUpdate(response, productFormComponent, variantId);
          return response;
        })
        .catch(function (error) {
          console.error('[greeting-card-addon]', error);
          alert(error.message);
        })
        .finally(function () {
          endFormLoading(productFormComponent);
        });
    }

    function addWithGreetingCards(cards) {
      closeModal();

      if (!cards || cards.length === 0) {
        const form = getProductForm();
        if (!isProductLineNoteValid(form)) {
          return;
        }

        bypassGreetingCard = true;
        if (form) {
          form.dataset.greetingCardProceed = 'true';
          form.requestSubmit();
        }
        resetModal();
        return;
      }

      submitCartWithGreetingCards(cards).then(function () {
        resetModal();
      });
    }

    function handleCountNext() {
      const { countInput } = getModalElements();
      if (!countInput) return;

      const count = parseInt(countInput.value, 10);
      clearCountError();

      if (!Number.isFinite(count) || count < 0 || count > wizard.mainQty) {
        setCountError(formatGreetingCardString(strings.errorCountRange, { max: wizard.mainQty }));
        countInput.focus();
        return;
      }

      if (count === 0) {
        addWithGreetingCards(null);
        return;
      }

      wizard.cardCount = count;
      wizard.cards = Array.from({ length: count }, function () {
        return { variantId: '', message: '' };
      });
      wizard.step = 'intro';
      updateStepUI();
    }

    function handleIntroNext() {
      wizard.step = 'card';
      wizard.currentCardIndex = 0;
      buildMessagePanels(wizard.cardCount);
      loadCardFromState(0);
    }

    function handleCardNext() {
      if (isTransitioning || !validateCurrentCard()) return;

      saveCurrentCardToState();

      const nextIndex = wizard.currentCardIndex + 1;
      if (nextIndex >= wizard.cardCount) return;

      isTransitioning = true;
      setTimeout(function () {
        loadCardFromState(nextIndex);
        isTransitioning = false;
      }, 50);
    }

    function handleBack() {
      if (wizard.step === 'intro') {
        wizard.step = 'count';
        updateStepUI();
        return;
      }

      if (wizard.step === 'card') {
        if (wizard.currentCardIndex > 0) {
          saveCurrentCardToState();
          loadCardFromState(wizard.currentCardIndex - 1);
          return;
        }

        saveCardFromDom(wizard.currentCardIndex);
        wizard.step = 'intro';
        updateStepUI();
      }
    }

    function handleConfirm(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (isTransitioning) return;

      if (wizard.step === 'card' && wizard.currentCardIndex < wizard.cardCount - 1) {
        return;
      }

      if (!validateCurrentCard()) return;

      saveCurrentCardToState();

      if (wizard.step === 'single') {
        addWithGreetingCards([
          {
            variantId: ensureCardSlot(0).variantId,
            message: normalizeMessageForProperty(ensureCardSlot(0).message),
          },
        ]);
        return;
      }

      saveCardFromDom(wizard.currentCardIndex);

      const incompleteIndex = wizard.cards.findIndex(function (card) {
        return !isCardComplete(card);
      });

      if (incompleteIndex !== -1) {
        alert(formatGreetingCardString(strings.errorIncompleteCard, { number: incompleteIndex + 1 }));
        loadCardFromState(incompleteIndex);
        return;
      }

      addWithGreetingCards(
        wizard.cards.map(function (card) {
          return {
            variantId: String(card.variantId || ''),
            message: normalizeMessageForProperty(card.message),
          };
        })
      );
    }

    function handleFormSubmit(event) {
      if (bypassGreetingCard) {
        bypassGreetingCard = false;
        return;
      }

      const submitButton = getSubmitButton();
      if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true' || submitButton.disabled) {
        return;
      }

      if (!isProductLineNoteValid(getProductForm())) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      openModal();
    }

    function setupFormIntercept() {
      const form = getProductForm();
      if (!form || form.dataset.greetingCardIntercept === 'true') return;

      form.dataset.greetingCardIntercept = 'true';
      form.addEventListener('submit', handleFormSubmit, true);
    }

    function selectVariantCard(card) {
      const els = getModalElements();
      if (!card || !els.variantCards.length) return;

      els.variantCards.forEach(function (variantCard) {
        variantCard.classList.remove('is-selected');
        variantCard.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      if (els.selectedVariantInput) {
        els.selectedVariantInput.value = card.dataset.variantId;
      }
      if (wizard.step === 'card' || wizard.step === 'single') {
        ensureCardSlot(wizard.currentCardIndex).variantId = card.dataset.variantId;
      }
    }

    function getLightboxElements() {
      return {
        lightbox: document.getElementById('flower-addon-lightbox'),
        image: document.getElementById('flower-addon-lightbox-image'),
        closeButton: document.getElementById('flower-addon-lightbox-close'),
      };
    }

    function openLightbox(src, alt) {
      const { lightbox, image, closeButton } = getLightboxElements();
      if (!lightbox || !image || !src) return;

      if (lightbox.parentElement !== document.body) {
        document.body.appendChild(lightbox);
      }

      image.src = src;
      image.alt = alt || '';
      lightbox.hidden = false;
      lightbox.style.display = 'flex';
      document.addEventListener('keydown', handleLightboxKeydown);
      if (closeButton) closeButton.focus();
    }

    function closeLightbox() {
      const { lightbox, image } = getLightboxElements();
      if (!lightbox) return;

      lightbox.hidden = true;
      lightbox.style.display = '';
      if (image) {
        image.removeAttribute('src');
        image.alt = '';
      }
      document.removeEventListener('keydown', handleLightboxKeydown);
    }

    function handleLightboxKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
      }
    }

    function setupModal() {
      const els = getModalElements();
      if (!els.modal || !els.confirmButton || !els.skipButton) return;
      if (els.modal.dataset.greetingCardSetup === 'true') return;

      els.modal.dataset.greetingCardSetup = 'true';

      els.variantCards.forEach(function (card) {
        card.addEventListener('click', function () {
          selectVariantCard(card);
        });

        card.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          selectVariantCard(card);
        });
      });

      els.modal.querySelectorAll('.flower-addon-card__zoom').forEach(function (zoomButton) {
        zoomButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          const src =
            zoomButton.getAttribute('data-lightbox-src') || zoomButton.dataset.lightboxSrc || '';
          const alt =
            zoomButton.getAttribute('data-lightbox-alt') || zoomButton.dataset.lightboxAlt || '';
          openLightbox(src, alt);
        });
      });

      const lightboxEls = getLightboxElements();
      if (lightboxEls.lightbox) {
        lightboxEls.lightbox.addEventListener('click', function (event) {
          if (event.target === lightboxEls.lightbox) {
            closeLightbox();
          }
        });
      }
      if (lightboxEls.closeButton) {
        lightboxEls.closeButton.addEventListener('click', function (event) {
          event.preventDefault();
          closeLightbox();
        });
      }

      els.skipButton.addEventListener('click', function () {
        addWithGreetingCards(null);
      });

      els.backButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        handleBack();
      });

      els.nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (wizard.step === 'count') {
          handleCountNext();
        } else if (wizard.step === 'intro') {
          handleIntroNext();
        } else if (wizard.step === 'card') {
          handleCardNext();
        }
      });

      els.confirmButton.addEventListener('click', handleConfirm);

      if (els.countInput) {
        els.countInput.addEventListener('input', clearCountError);
      }

      els.modal.addEventListener('click', function (event) {
        if (event.target === els.modal) {
          closeModal();
        }
      });

      if (typeof subscribe !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
          if (!els.modal || els.modal.style.display !== 'flex') return;

          wizard.mainQty = getMainQuantity();

          if (wizard.step === 'count' && els.countInput) {
            els.countInput.max = String(wizard.mainQty);
            if (parseInt(els.countInput.value, 10) > wizard.mainQty) {
              els.countInput.value = String(wizard.mainQty);
            }
            if (els.countDescription) {
              els.countDescription.textContent = formatGreetingCardString(strings.countDescription, {
                quantity: wizard.mainQty,
              });
            }
          }
        });
      }

      updateStepUI();
    }

    function init() {
      if (!getProductForm() || !getSubmitButton()) return false;
      setupFormIntercept();
      setupModal();
      return true;
    }

    if (typeof subscribe !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event.data && event.data.sectionId === sectionId) {
          setupFormIntercept();
        }
      });
    }

    function waitForProductForm() {
      let attempts = 0;
      const timer = setInterval(function () {
        attempts += 1;
        if (init() || attempts > 100) {
          clearInterval(timer);
        }
      }, 100);
    }

    waitForProductForm();
  }

  function bootstrap() {
    const modal = document.getElementById('flower-addon-modal');
    if (!modal) return;

    const sectionId = modal.dataset.sectionId;
    const productFormId = modal.dataset.productFormId;
    if (!sectionId || !productFormId) return;

    initGreetingCardAddon(sectionId, productFormId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  /* Agrotropic Grusskarten Modul Ende */
})();
